import { keyframes } from '@emotion/react';

export const animation = {
  bouncing: keyframes`
    0%{
      transform: translateY(0);
    }
    50%{
      transform: translateY(-15px);
    }
    100%{
      transform: translateY(0);
    }
  `,
  navbar: keyframes`
    from{
      transform: translateY(-100%);
    }
    to{
      transform: translateY(0);
    }
  `,
};
